import { IconButton, styled } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import colors from "../theme/themeConstants";
import { SearchInput } from "components/UI/SearchInput";
import { HeaderButton } from "./buttons/HeaderButton";
import { toggleBurgerMenu } from "store/application/application-action";
import { useSelector, useDispatch } from "react-redux";
import { IAppState } from "../store/app-state";
import { RGLogo } from "components/UI/RGLogo";
import AdTabs from "./ads/AdTabs";
import { TABLET_WIDTH } from "hooks/useDeviceType";

import "./ApplicationHeader.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "routes";
import CrossIcon from "./icons/Components/CrossIcon";
import { Fragment } from "react";

export default function ApplicationHeader() {
  const isSearchBarOpen = useSelector((state: IAppState) => state.application.isSearchBarOpen);
  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);
  const dispatch = useDispatch();
  const isShowSearchElems = isDesktop || (!isDesktop && !isSearchBarOpen);

  const location = useLocation();
  const navigate = useNavigate();

  const handleBurgerMenuButton = () => {
    dispatch(toggleBurgerMenu());
  };

  return (
    <>
      {!location.pathname.includes(routes.create()) ? (
        <HeaderToolsWraper className="topNav">
          {isShowSearchElems && <RGLogo />}
          {!isSearchBarOpen && <AdTabs />}
          <SearchInput/>
          {isShowSearchElems && <HeaderButton onClick={handleBurgerMenuButton}/>}
        </HeaderToolsWraper>
      ) : (
        <HeaderToolsWraper className="topNav">
          {isShowSearchElems && <RGLogo />}
          {isDesktop ? (
            <Fragment>
              {!isSearchBarOpen && <AdTabs />}
              <SearchInput/>
              {isShowSearchElems && <HeaderButton onClick={handleBurgerMenuButton}/>}
            </Fragment>
          ) : (
            <Fragment>
              <UploadTitle>Upload</UploadTitle>
              <IconButton
                sx={{
                  transform: "rotate(45deg)",
                  color: colors.lightGrayText,
                  background: colors.lightGray_GoBackButton
                }}
                onClick={() => navigate(-1)}
              >
                <CrossIcon/>
              </IconButton>
            </Fragment>
          )}
        </HeaderToolsWraper>
      )}
    </>
  );
}

const HeaderToolsWraper = styled("div")({
  backgroundColor: colors.backgroundBlack,
  width: "100%",
  height: "68px",
  top: 0,
  color: colors.white,
  margin: "auto",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  position: "relative",
  padding: "0 16px",
  borderBottom: `1px solid ${colors.lightGray}`,
  ".desktop &": {
    justifyContent: "flex-start",
  },
});

const UploadTitle = styled("p")({
  position: "absolute",
  marginLeft: "auto",
  marginRight: "auto",
  left: 0,
  right: 0,
  textAlign: "center"
});
